import { instance, GETREQUESTOPTIONS } from '../apiService';
import { MRIMachinePopulated } from '../../components/room-overview/types';

export interface GradientDiameterResultDTO {
    diameter: string;
    machineValue: number;
    isWithinLimit: boolean;
}

export interface GradientAnalysisDTO {
    implantMaxGradient: number;
    diameterResults: GradientDiameterResultDTO[];
}

export interface MachineCompatibilityDTO {
    machine: Pick<
        MRIMachinePopulated,
        'location' | 'category' | 'equipment' | 'policies'
    > & {
        _id: string;
        Name: string;
        Model: string;
        Manufacturer: string;
        FieldStrength: number;
        TRCoils?: string;
    };
    isRestricted: boolean;
    gradientAnalysis: GradientAnalysisDTO | null;
}

export interface MachineCompatibilityResponseDTO {
    results: MachineCompatibilityDTO[];
    implantCoilWarning: string | null;
    warnings: string[];
}

export const getMachineCompatibility = async (
    conditionalId: string
): Promise<MachineCompatibilityResponseDTO> => {
    const res = await instance.get(
        `/api/room-overview/compatibility/${conditionalId}`,
        GETREQUESTOPTIONS()
    );
    return res.data;
};
